import React from 'react';
import Header from './Header';
import Main from './Main';
import ReactGA from 'react-ga';

class App extends React.Component{
	render() {
		ReactGA.initialize('UA-109839577-1', {
		  debug: true,
		  titleCase: false,
		  gaOptions: {
		    userId: 123
		  }
		});
		ReactGA.pageview(window.location.pathname + window.location.search);
		return (
			<div className="portfolio">
				<Header />
				<Main />
			</div>
			)
		}
	}

export default App;


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/